/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import { formsValidationErrors, isEmptyOrSpaces } from '@/helpers/form';
import { apiModule, isValidMiladyDate, isValidHijriDate } from '@/helpers/utils';
import lawsuitRequestValidations from '@/modules/lawsuit/helpers/validations';
import systemRequestValidations from '@/modules/system/helpers/validations';
import axios from 'axios';
import VeeValidate, { Validator } from 'vee-validate';
import ar from 'vee-validate/dist/locale/ar';
import Vue from 'vue';
import { socialIdentityTypeEnum } from '@/helpers/enum';
import { calculateAge } from '@/modules/lawsuit/helpers/utils';
const addExtraMessagesToLocal = (local, extraMessages) => {
  return Object.assign({}, local, { messages: Object.assign({}, local.messages, extraMessages) });
};

Vue.use(VeeValidate, {
  locale: 'ar',
  dictionary: {
    ar: addExtraMessagesToLocal(ar, {
      numeric: label => `${label} يجب أن يكون أرقام فقط`,
      digits: (label, value) => `${label} يجب أن يكون أرقام فقط ومكون من ${value} أرقام`,
      min: (label, value) => `${label} يجب أن يحتوي على ${value} حرف على الأقل`,
      max: (label, value) => `${label} يجب أن يحتوي على ${value} حرف على الأكثر`,
      min_value: (label, value) => `${label} يجب أن تكون اكبر من ${value} أو تساويها`,
      max_value: (label, value) => `${label} يجب أن تكون افل من ${value} أو تساويها`,
    }),
  },
  fieldsBagName: 'fieldsBag',
});

Validator.extend('arabic', {
  getMessage: () => formsValidationErrors.writeArabicOnly,
  validate: value =>
    !!value &&
    !/[^\u0600-\u06FF\d\s\`\~\!\@\#\$\%\^\&\*\(\)\-\_\=\+\<\>\|\[\{\]\}\;\:\'\"\\\|\,\<\.\>\/\?]/g.test(
      value
    ) &&
    /[\u0600-\u06FF]/.test(value),
});

Validator.extend('no_english_letters', {
  getMessage: () => 'لا يمكن أن يحتوي على رموز خاصة حروف انجليزية',
  validate: value => !!value && !/[A-Za-z]/g.test(value),
});

Validator.extend('max_number_length', {
  paramNames: ['length'],
  getMessage: (label, value) => `${label} يجب أن يحتوي على ${value} رقم على الأكثر`,
  validate: (value, { length }) => {
    return (value || '').toString().split('.')[0].length <= (+length || 10);
  },
});

Validator.extend('arabic_letters', {
  getMessage: () => 'يرجى إدخال حروف عربية',
  validate: value => !!value && !/[^\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\s]/g.test(value),
});
Validator.extend('english_letters', {
  getMessage: () => 'يرجى إدخال حروف انجليزية فقط بدون مسافات',
  validate: (value) => { return /^[A-Za-z.][A-Za-z0-9.]*$/.test(value); },
});
Validator.extend('english_letters_numbers', {
  getMessage: () => 'يرجى إدخال حروف انجليزية فقط بدون مسافات',
  validate: (value) => { return /^[A-Za-z0-9]+$/.test(value); },
});
Validator.extend('no_special_char', {
  getMessage: () => 'لا يمكن أن يحتوي على رموز خاصة',
  validate: value =>
    !!value &&
    !/[\\`\~\!\@\#\$\%\^\&\*\(\)\-\_\=\+\<\>\|\[\{\]\}\;\:\'\"\\\|\,\<\.\>\/\?]/g.test(value),
});
Validator.extend('no_special_character', {
  getMessage: () => 'لا يمكن أن يحتوي على رموز خاصة',
  validate: value =>
    !!value &&
    !/[\\`\~\@\#\$\%\^\&\*\-\_\=\+\<\>\|\[\{\]\}\;\\\|\<\>\/]/g.test(value),
});

Validator.extend('allowed_special_character', {
  getMessage: () => 'مسموح فقط بالرموز الخاصة التالية: (! * - ( ) # ? @ / ^ ~ . : ،)',
  validate: value =>
    !!value &&
    !/[\`\$\%\&\_\=\+\<\>\|\[\{\]\}\;\|\<\>]/g.test(value),
});
Validator.extend('validiBAN', {
  getMessage: () => 'رقم الآيبان غير صحيح',
  validate: value =>
    !!value &&
    value.length == 24 &&
    /^SA\d{4}[0-9A-Z]{18}/g.test(value),
});
Validator.extend('checkIfFirstCharStartsBy', {
  paramNames: ['number'],
  getMessage: (field, number) =>
    formsValidationErrors.shouldNumberStartBy(number?.toString()),
  validate: (value, { number }) => !!value && value.toString()[0] == number,
});

Validator.extend('socialId', {
  paramNames: ['typeId'],
  getMessage(field, args, data) {
    return data.msg;
  },
  validate(value, { typeId }) {
    const socialTypeId = typeId.replace('\n', '')
      .trim();
    const socialTypeIdsLimitedLength = [socialIdentityTypeEnum.nationalId, socialIdentityTypeEnum.regularResidency, socialIdentityTypeEnum.borderNumber];
    const socialTypeIdsAllowDashes = [socialIdentityTypeEnum.gulfCountry];
    const regexSpecialCharacters = /[\\`\~\!\@\#\$\%\^\&\*\(\)\-\_\=\+\<\>\|\[\{\]\}\;\:\'\"\\\|\,\<\.\>\/\?]/g;
    const englishLetters = /^[A-Za-z0-9]*$/;
    const englishLettersWithDash = /^[A-Za-z0-9-]*$/;
    if (value?.trim()?.length > 50) return { data: { msg: formsValidationErrors.maxLength(50) } };
    if (!englishLetters.test(value) && socialTypeIdsAllowDashes.indexOf(+socialTypeId) === -1)
      return { data: { msg: formsValidationErrors.shouldEnglishLettersOrNumbers } };
    if (regexSpecialCharacters.test(value) && socialTypeIdsAllowDashes.indexOf(+socialTypeId) === -1)
      return { data: { msg: formsValidationErrors.noSpecialCharacter } };
    if ((socialTypeIdsAllowDashes.indexOf(+socialTypeId) !== -1 && !!value && !englishLettersWithDash.test(value)))
      return { data: { msg: formsValidationErrors.shouldEnglishLettersOrNumbers } };
    if (socialTypeId == socialIdentityTypeEnum.nationalId && !!value && !value.startsWith('1'))
      return { data: { msg: formsValidationErrors.shouldNumberStartBy('1') } };
    else if (socialTypeId == socialIdentityTypeEnum.regularResidency && !!value && !value.startsWith('2'))
      return { data: { msg: formsValidationErrors.shouldNumberStartBy('2') } };
    // commented out for US 812129
    // else if ((socialTypeId == socialIdentityTypeEnum.tempResidency && !!value && (!value.startsWith('2'))))
    //   return { data: { msg: formsValidationErrors.shouldNumberStartBy('2') } };
    else if ((socialTypeId == socialIdentityTypeEnum.visitor && !!value && (!value.startsWith('3') && !value.startsWith('4') && !value.startsWith('5'))))
      return { data: { msg: formsValidationErrors.shouldNumberStartBy('3,4,5') } };
    else if ((socialTypeId == socialIdentityTypeEnum.borderNumber && !!value && (!value.startsWith('3') && !value.startsWith('4') && !value.startsWith('5') && !value.startsWith('6'))))
      return { data: { msg: formsValidationErrors.shouldNumberStartBy('3,4,5,6') } };
    else if ((socialTypeId == socialIdentityTypeEnum.identityOfMotamer && !!value && !value.startsWith('6')))
      return { data: { msg: formsValidationErrors.shouldNumberStartBy('6') } };
    if (value.trim().length != 10 && socialTypeIdsLimitedLength.indexOf(+socialTypeId) !== -1)
      return { data: { msg: formsValidationErrors.shouldSocialIdNumberIn10Digits } };
    else
      return { valid: true };
  },
});
Validator.extend('isVerified', {
  paramNames: ['isVerified'],
  getMessage: field => 'الرجاء التحقق من البيانات',
  validate: (value, { isVerified }) => isVerified == 'true',
});
Validator.extend('verification_code', {
  paramNames: ['code'],
  getMessage: () => 'كود التحقق غير صحيح',
  validate: (value, { code }) => (value || '').toString().trim().toUpperCase() === (code || '').toString().trim().toUpperCase(),
});
Validator.extend('phone', {
  getMessage: field => formsValidationErrors.shouldPhoneNumberStartWith05,
  validate: value => !!value && value.length && value[0] == 0 && value[1] == 5,
});
Validator.extend('string', {
  paramNames: ['length'],
  getMessage: field => `${field} تجاوز الحد المسموح`,
  validate: (value, { length }) => {
    return (value || '').toString().length <= (+length || 100);
  },
});
Validator.extend('int', {
  paramNames: ['disabled'],
  getMessage: field => `${field} تجاوز الحد المسموح`,
  validate: (value, { disabled }) => disabled == 'true' || value <= 2147483648,
});
Validator.extend('number', {
  paramNames: ['disabled'],
  getMessage: () => 'يجيب أن يحتوي على أرقام فقط',
  validate: (value, { disabled }) => disabled == 'true' || value <= 2147483648,
});
Validator.extend('long', {
  paramNames: ['disabled'],
  getMessage: field => `${field} تجاوز الحد المسموح`,
  validate: (value, { disabled }) => disabled == 'true' || value <= 9223372036854775808,
});
Validator.extend('hijri_year', {
  paramNames: ['gregorianYear'],
  getMessage: label => `${label} يجب أن يكون أصغر من أو يساوي العام الحالي`,
  validate: (value, { gregorianYear }) => +value <= +getHijriYear(gregorianYear),
});
Validator.extend('age', {
  paramNames: ['year'],
  getMessage: (field, year) => formsValidationErrors.age(year),
  validate: (value, { year }) => isValidHijriDate(value) || Math.floor(calculateAge(value)) === +year,
});
Validator.extend('max_age', {
  paramNames: ['year'],
  getMessage: (field, year) => formsValidationErrors.max_age(year),
  validate: (value, { year }) => isValidHijriDate(value) || calculateAge(value) < +year,
});
Validator.extend('min_age', {
  paramNames: ['year'],
  getMessage: (field, year) => formsValidationErrors.min_age(year),
  validate: (value, { year }) => isValidHijriDate(value) || calculateAge(value) >= +year,
});
Validator.extend('not_equal', {
  paramNames: ['otherValue', 'message'],
  getMessage: (label, [otherValue, message]) => `${message ? message : (label + ' يجب ألا يساوي ' + otherValue)}`,
  validate: (value, { otherValue }) => value !== otherValue,
});
Validator.extend('error', {
  paramNames: ['errorMessage'],
  validate: () => false,
  getMessage: (label, errorMessage) => errorMessage,
});
Validator.extend('isValid', {
  paramNames: ['errorMessage', 'valid'],
  validate: (value, { valid }) => (String(valid) || '').trim() == 'true',
  getMessage: (label, [errorMessage]) => errorMessage, // the first param (errorMessage)
});
Validator.extend(
  'conditionalRequired',
  {
    paramNames: ['validationEnabled'],
    validate: (value, { validationEnabled }) => {
      const returnValue =
        !validationEnabled || validationEnabled == 'false' ? true : !isEmptyOrSpaces(value);
      return {
        valid: returnValue,
        data: { required: !returnValue },
      };
    },
    getMessage: field => `${field} مطلوب`,
  },
  { computesRequired: true }
);
Validator.extend('external_validation', {
  paramNames: ['requestType', 'module', 'endpoint', 'expectedStatus', 'expectedResults'],
  validate: (value, params) => {
    const modulePrefix = params.module ? apiModule[params.module] : '';
    return axios[params.requestType](`${modulePrefix}${params.endpoint}`, { params: { value } })
      .then(response => dynamicValidatorHandler(response, params))
      .catch(({ response }) => dynamicValidatorHandler(response, params));
  },
  getMessage: (field, params, msg) => 'الحقل غير صالح',
});

Validator.extend('isValidTechnicalName', {
  getMessage: label => `${label} يجب أن يكون كلمة انجليزية بدون مسافات و تبدأ بحرف صغير مثل "camelCase"`,
  validate: (value) => {
    return /^[a-z]+[a-zA-Z0-9]*$/.test(value);
  },
});

Validator.extend('no_gov_email', {
  getMessage: () => 'عفواً لايمكنك إضافة بريد لجهة رسمية',
  validate: value =>
    !value.toLowerCase()
      .endsWith('gov.sa'),
});

Validator.extend('only-digits', {
  getMessage: (label, value) => `${label} يجب أن يحتوي على ${value} أرقام فقط`,
  validate: value => /^\d+$/.test(value),
});

// Enforces the field to be entirely Arabic letters/spaces OR entirely English letters/spaces (no mix, no digits/specials)
Validator.extend('single_language_field', {
  getMessage: () => 'الحقل يجب أن يكون كاملاً بالعربية أو كاملاً بالإنجليزية',
  validate: value => {
    if (!value) return true;
    const arabicRegex = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\s]+$/;
    const englishRegex = /^[A-Za-z\s]+$/;
    const isArabic = arabicRegex.test(value);
    const isEnglish = englishRegex.test(value);
    return (isArabic || isEnglish) && !(isArabic && isEnglish);
  },
});
// Ensures all provided name values share the same language (Arabic-only or English-only)
Validator.extend('consistent_name_language', {
  paramNames: ['siblings'],
  getMessage: () => 'حقول الاسم يجب أن تكون بنفس اللغة',
  validate: (value, { siblings }) => {
    // siblings is a single string concatenated with ~~~ between values
    const values = (siblings || '').split('~~~').filter(v => (v || '').trim().length > 0);
    // include current value in the check
    if ((value || '').trim().length > 0) values.push(String(value));
    if (values.length <= 1) return true; // nothing to compare

    const arabicRegex = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\s]+$/;
    const englishRegex = /^[A-Za-z\s]+$/;

    // Check if each value is Arabic or English
    let hasArabic = false;
    let hasEnglish = false;

    for (const v of values) {
      const isArabic = arabicRegex.test(v);
      const isEnglish = englishRegex.test(v);

      // If a value is neither valid Arabic nor valid English, fail
      if (!isArabic && !isEnglish) return false;

      if (isArabic) hasArabic = true;
      if (isEnglish) hasEnglish = true;

      // If we found both languages, fail immediately
      if (hasArabic && hasEnglish) return false;
    }

    // All values are in the same language
    return true;
  },
});

const otherValidations = {
  ...lawsuitRequestValidations,
  ...systemRequestValidations,
};

Object.keys(otherValidations).forEach((key) => {
  Validator.extend(key, otherValidations[key]);
});

const getHijriYear = (gregorianYear) => {
  const year = Number(gregorianYear);
  return new Intl.DateTimeFormat('ar-u-ca-islamic', { year: 'numeric' })
    .format(!isNaN(year) && year ? new Date(Date.UTC(year)) : new Date())
    .replace(/\D/g, '');
};

const dynamicValidatorHandler = (res, params) => {
  let isValid = true;
  if (params.expectedStatus) {
    isValid = params.expectedStatus == res.status;
  }
  if (params.expectedResults) {
    isValid = params.expectedResults == res.data;
  }
  return {
    valid: isValid,
    data: res.data,
  };
};
export const veeValidator = Validator;
